module.exports = __webpack_public_path__ + "img/none_box.03485194.png";